<header class="portal-header">
  <div class="welcome">
    <p>{{ greeting }}, <strong>{{ currentUserName }}</strong></p>
    <div class="date-time">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9"></circle>
        <path d="M12 7v5l3 2"></path>
      </svg>
      <time [attr.datetime]="currentDateTime().toISOString()">
        <span class="date-value">{{ currentDateTime() | date: 'EEEE, d MMMM y' }}</span>
        <span class="separator" aria-hidden="true">•</span>
        <span class="clock-value">{{ currentDateTime() | date: 'h:mm:ss a' }}</span>
      </time>
    </div>
  </div>

  <div class="header-actions">
    <button type="button" class="notification-button" aria-label="Notifications">◌</button>
    <button
      type="button"
      class="theme-toggle"
      (click)="themeService.toggleTheme()"
      [attr.aria-label]="themeService.isDarkMode() ? 'Switch to light mode' : 'Switch to dark mode'"
      [attr.aria-pressed]="themeService.isDarkMode()"
      [title]="themeService.isDarkMode() ? 'Switch to light mode' : 'Switch to dark mode'"
    >
      @if (themeService.isDarkMode()) {
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="4"></circle>
          <path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.66 6.34l1.41-1.41"></path>
        </svg>
      } @else {
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M20.5 14.2A8.5 8.5 0 0 1 9.8 3.5 8.5 8.5 0 1 0 20.5 14.2Z"></path>
        </svg>
      }
    </button>
    <div class="profile-wrap">
      <button
        type="button"
        class="profile"
        (click)="$event.stopPropagation(); toggleProfileMenu()"
        aria-label="Open profile menu"
        aria-haspopup="menu"
        [attr.aria-expanded]="isProfileMenuOpen"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="8" r="3.5"></circle>
          <path d="M5.5 20c.5-4 2.7-6 6.5-6s6 2 6.5 6"></path>
        </svg>
      </button>

      @if (isProfileMenuOpen) {
        <div class="profile-menu" role="menu" (click)="$event.stopPropagation()">
          <div class="profile-summary">
            <div class="profile-summary__avatar" aria-hidden="true">
              @if (currentUser?.profile_image) {
                <img [src]="currentUser.profile_image" alt="">
              } @else {
                {{ profileInitial }}
              }
            </div>
            <div>
              <strong>{{ currentUserName }}</strong>
              <span>{{ currentUser?.email || 'Signed-in user' }}</span>
              @if (currentUser?.role?.name) {
                <small>{{ currentUser.role.name }}</small>
              }
            </div>
          </div>

          <div class="profile-menu__links">
            <a routerLink="/profile" role="menuitem" (click)="closeProfileMenu()">My Profile</a>
            <a routerLink="/change-password" role="menuitem" (click)="closeProfileMenu()">Change Password</a>
            <button type="button" role="menuitem" (click)="logout()">Logout</button>
          </div>
        </div>
      }
    </div>
  </div>
</header>
